/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.206.1-v202610051731-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqTemplatesApiClass {
 
   constructor() {}

  /**
   * @summary Apply a template once by providing inputs to the template's features. This endpoint is experimental and may change in future releases.
   * @param {string} templateId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public applyTemplate(
    body: models.TemplateInitialApplicationInputV1,
    {
      templateId
    } : {
      templateId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (templateId === null || templateId === undefined) {
      throw new Error("'templateId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/${encodeURIComponent(String(templateId))}/instances`
      .replace('{templateId}', encodeURIComponent(String(templateId)));
    const urlTemplate = `${baseUrl}/templates/{templateId}/instances`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.InstanceOutputV1>;
  }

  /**
   * @summary Apply a template to a table definition and recompute the newly-added columns. This endpoint is experimental and may change in future releases.
   * @param {string} templateId
   * @param {string} tableDefinitionId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public applyTemplateToTable(
    body: models.TableTemplateApplicationInputV1,
    {
      templateId,
      tableDefinitionId
    } : {
      templateId: string,
      tableDefinitionId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (templateId === null || templateId === undefined) {
      throw new Error("'templateId' parameter required");
    }

    if (tableDefinitionId === null || tableDefinitionId === undefined) {
      throw new Error("'tableDefinitionId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/${encodeURIComponent(String(templateId))}/table-application/${encodeURIComponent(String(tableDefinitionId))}`
      .replace('{templateId}', encodeURIComponent(String(templateId)))
      .replace('{tableDefinitionId}', encodeURIComponent(String(tableDefinitionId)));
    const urlTemplate = `${baseUrl}/templates/{templateId}/table-application/{tableDefinitionId}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TemplateTableApplicationOutputV1>;
  }

  /**
   * @summary Archive a template by its ID. This endpoint is experimental and may change in future releases.
   * @param {string} id - ID of the template to archive
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public archiveTemplate(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/templates/{id}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Create a new draft from a published version. This endpoint is experimental and may change in future releases.
   * @param {string} templateId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public createDraft(
    {
      templateId,
    } : {
      templateId: string,
    },
    body?: models.TemplateDraftCreateInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (templateId === null || templateId === undefined) {
      throw new Error("'templateId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/${encodeURIComponent(String(templateId))}/drafts`
      .replace('{templateId}', encodeURIComponent(String(templateId)));
    const urlTemplate = `${baseUrl}/templates/{templateId}/drafts`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TemplateOutputV1>;
  }

  /**
   * @summary Create a new template. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public createTemplate(
    body: models.TemplateInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates`;
    const urlTemplate = `${baseUrl}/templates`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TemplateOutputV1>;
  }

  /**
   * @summary Create a new template from reference items. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public createTemplateFromItems(
    body: models.TemplateFromIdsInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/from-items`;
    const urlTemplate = `${baseUrl}/templates/from-items`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TemplateOutputV1>;
  }

  /**
   * @summary Create a new template from reference column definitions. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public createTemplateFromTableColumnDefinitions(
    body: models.TemplateFromIdsInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/from-table-column-definitions`;
    const urlTemplate = `${baseUrl}/templates/from-table-column-definitions`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TemplateOutputV1>;
  }

  /**
   * @summary Diff two template versions for compatibility. This endpoint is experimental and may change in future releases.
   * @param {string} baseTemplateId - ID of the base template version
   * @param {string} candidateTemplateId - ID of the candidate template version
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public diffTemplates(
    {
      baseTemplateId,
      candidateTemplateId
    } : {
      baseTemplateId: string,
      candidateTemplateId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (baseTemplateId === null || baseTemplateId === undefined) {
      throw new Error("'baseTemplateId' parameter required");
    }

    if (candidateTemplateId === null || candidateTemplateId === undefined) {
      throw new Error("'candidateTemplateId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/${encodeURIComponent(String(baseTemplateId))}/diff/${encodeURIComponent(String(candidateTemplateId))}`
      .replace('{baseTemplateId}', encodeURIComponent(String(baseTemplateId)))
      .replace('{candidateTemplateId}', encodeURIComponent(String(candidateTemplateId)));
    const urlTemplate = `${baseUrl}/templates/{baseTemplateId}/diff/{candidateTemplateId}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.TemplateCompatibilityReportOutputV1>;
  }

  /**
   * @summary Duplicate a template by its ID. This endpoint is experimental and may change in future releases.
   * @param {string} templateId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public duplicateTemplate(
    body: models.TemplateDuplicateInputV1,
    {
      templateId
    } : {
      templateId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (templateId === null || templateId === undefined) {
      throw new Error("'templateId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/${encodeURIComponent(String(templateId))}/duplicate`
      .replace('{templateId}', encodeURIComponent(String(templateId)));
    const urlTemplate = `${baseUrl}/templates/{templateId}/duplicate`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TemplateOutputV1>;
  }

  /**
   * @summary Edit a template by ID. The full template must be provided. This endpoint is experimental and may change in future releases.
   * @param {string} templateId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public editTemplate(
    body: models.TemplateInputV1,
    {
      templateId
    } : {
      templateId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (templateId === null || templateId === undefined) {
      throw new Error("'templateId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/${encodeURIComponent(String(templateId))}`
      .replace('{templateId}', encodeURIComponent(String(templateId)));
    const urlTemplate = `${baseUrl}/templates/{templateId}`;



    return axiosInstance.request({
      method: 'put',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TemplateOutputV1>;
  }

  /**
   * @summary Edit a specific template version. The template must be unlocked (draft or initial). This endpoint is experimental and may change in future releases.
   * @param {string} templateId
   * @param {string} versionId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public editTemplateVersion(
    body: models.TemplateInputV1,
    {
      templateId,
      versionId
    } : {
      templateId: string,
      versionId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (templateId === null || templateId === undefined) {
      throw new Error("'templateId' parameter required");
    }

    if (versionId === null || versionId === undefined) {
      throw new Error("'versionId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/${encodeURIComponent(String(templateId))}/versions/${encodeURIComponent(String(versionId))}`
      .replace('{templateId}', encodeURIComponent(String(templateId)))
      .replace('{versionId}', encodeURIComponent(String(versionId)));
    const urlTemplate = `${baseUrl}/templates/{templateId}/versions/{versionId}`;



    return axiosInstance.request({
      method: 'put',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TemplateOutputV1>;
  }

  /**
   * @summary Generates a list of independent and dependent column definitions from a list of items. The independent column definitions do not rely on other columns, while the dependent column definitions do. This can be used to create a template table from calculations. This endpoint is experimental and may change in future releases.
   * @param {string} scopedTo - The ID of the Workbook that the formula creator column rules will be scoped to
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public generateColumnTemplate(
    body: models.ColumnTemplateInputV1,
    {
      scopedTo
    } : {
      scopedTo: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (scopedTo === null || scopedTo === undefined) {
      throw new Error("'scopedTo' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/templateData`;
    const urlTemplate = `${baseUrl}/templates/templateData`;

    const queryParams = {
      ['scopedTo']: scopedTo
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ColumnTemplateOutput>;
  }

  /**
   * @summary Count distinct Template Applications for a template. This endpoint is experimental and may change in future releases.
   * @param {string} id
   * @param {string} [worksheetId] - When provided, only one-off applications in this worksheet are counted
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getApplicationCountForTemplate(
    {
      id,
      worksheetId
    } : {
      id: string,
      worksheetId?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/${encodeURIComponent(String(id))}/applicationsCount`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/templates/{id}/applicationsCount`;

    const queryParams = {
      ['worksheetId']: worksheetId
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ApplicationCountOutputV1>;
  }

  /**
   * @summary Fetch the tables to which a template has been applied. This endpoint is experimental and may change in future releases.
   * @param {string} templateId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getAppliedTemplateTables(
    {
      templateId
    } : {
      templateId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (templateId === null || templateId === undefined) {
      throw new Error("'templateId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/${encodeURIComponent(String(templateId))}/tables`
      .replace('{templateId}', encodeURIComponent(String(templateId)));
    const urlTemplate = `${baseUrl}/templates/{templateId}/tables`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<Array<models.TableDefinitionOutputV1>>;
  }

  /**
   * @summary Get the current user's draft for a template container, if one exists. This endpoint is experimental and may change in future releases.
   * @param {string} templateId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getDraft(
    {
      templateId
    } : {
      templateId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (templateId === null || templateId === undefined) {
      throw new Error("'templateId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/${encodeURIComponent(String(templateId))}/draft`
      .replace('{templateId}', encodeURIComponent(String(templateId)));
    const urlTemplate = `${baseUrl}/templates/{templateId}/draft`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.TemplateOutputV1>;
  }

  /**
   * @summary Fetch template instance by ID
   * @param {string} instanceId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getInstance(
    {
      instanceId
    } : {
      instanceId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (instanceId === null || instanceId === undefined) {
      throw new Error("'instanceId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/instances/${encodeURIComponent(String(instanceId))}`
      .replace('{instanceId}', encodeURIComponent(String(instanceId)));
    const urlTemplate = `${baseUrl}/templates/instances/{instanceId}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.InstanceOutputV1>;
  }

  /**
   * @summary Fetch template instances for table definition ID
   * @param {string} tableDefinitionId
   * @param {number} [offset=0] - The pagination offset, the index of the first template instance that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of template instances that will be returned in this page of results
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getInstancesForTable(
    {
      tableDefinitionId,
      offset,
      limit
    } : {
      tableDefinitionId: string,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (tableDefinitionId === null || tableDefinitionId === undefined) {
      throw new Error("'tableDefinitionId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/instances/table/${encodeURIComponent(String(tableDefinitionId))}`
      .replace('{tableDefinitionId}', encodeURIComponent(String(tableDefinitionId)));
    const urlTemplate = `${baseUrl}/templates/instances/table/{tableDefinitionId}`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.InstanceOutputPaginatedListV1>;
  }

  /**
   * @summary Fetch template instances for template ID
   * @param {string} templateId
   * @param {number} [offset=0] - The pagination offset, the index of the first template instance that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of template instances that will be returned in this page of results
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getInstancesForTemplate(
    {
      templateId,
      offset,
      limit
    } : {
      templateId: string,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (templateId === null || templateId === undefined) {
      throw new Error("'templateId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/${encodeURIComponent(String(templateId))}/instances`
      .replace('{templateId}', encodeURIComponent(String(templateId)));
    const urlTemplate = `${baseUrl}/templates/{templateId}/instances`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.InstanceOutputPaginatedListV1>;
  }

  /**
   * @summary Get existing template applications to a given table definition. This endpoint is experimental and may change in future releases.
   * @param {string} id - The ID of the table definition
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getTableDefinitionTemplateApplications(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/${encodeURIComponent(String(id))}/template-applications`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/templates/{id}/template-applications`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.TemplateTableApplicationsOutputListV1>;
  }

  /**
   * @summary Fetch a template by ID. This endpoint is experimental and may change in future releases.
   * @param {string} templateId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getTemplate(
    {
      templateId
    } : {
      templateId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (templateId === null || templateId === undefined) {
      throw new Error("'templateId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/${encodeURIComponent(String(templateId))}`
      .replace('{templateId}', encodeURIComponent(String(templateId)));
    const urlTemplate = `${baseUrl}/templates/{templateId}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.TemplateOutputV1>;
  }

  /**
   * @summary Compute input/output dependency information for a template. This endpoint is experimental and may change in future releases.
   * @param {string} templateId
   * @param {Array<string>} [selectedOutputCanonicalIds] - Canonical IDs of the outputs to analyze. Omitted or empty analyzes all outputs.
   * @param {Array<string>} [mappedInputCanonicalIds] - Canonical IDs of the inputs the caller has mapped. When non-empty, the response includes achievableOutputs.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getTemplateDependencies(
    {
      templateId,
      selectedOutputCanonicalIds,
      mappedInputCanonicalIds
    } : {
      templateId: string,
      selectedOutputCanonicalIds?: Array<string>,
      mappedInputCanonicalIds?: Array<string>
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (templateId === null || templateId === undefined) {
      throw new Error("'templateId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/${encodeURIComponent(String(templateId))}/dependencies`
      .replace('{templateId}', encodeURIComponent(String(templateId)));
    const urlTemplate = `${baseUrl}/templates/{templateId}/dependencies`;

    const queryParams = {
      ['selectedOutputCanonicalIds']: selectedOutputCanonicalIds,      ['mappedInputCanonicalIds']: mappedInputCanonicalIds
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.TemplateDependenciesOutputV1>;
  }

  /**
   * @summary Fetch the full template for a specific published version. This endpoint is experimental and may change in future releases.
   * @param {string} templateId
   * @param {string} versionId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getTemplateVersion(
    {
      templateId,
      versionId
    } : {
      templateId: string,
      versionId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (templateId === null || templateId === undefined) {
      throw new Error("'templateId' parameter required");
    }

    if (versionId === null || versionId === undefined) {
      throw new Error("'versionId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/${encodeURIComponent(String(templateId))}/versions/${encodeURIComponent(String(versionId))}`
      .replace('{templateId}', encodeURIComponent(String(templateId)))
      .replace('{versionId}', encodeURIComponent(String(versionId)));
    const urlTemplate = `${baseUrl}/templates/{templateId}/versions/{versionId}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.TemplateOutputV1>;
  }

  /**
   * @summary List all published versions of a template. This endpoint is experimental and may change in future releases.
   * @param {string} templateId
   * @param {number} [offset=0] - The pagination offset, the index of the first version that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of versions that will be returned in this page of results
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getTemplateVersions(
    {
      templateId,
      offset,
      limit
    } : {
      templateId: string,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (templateId === null || templateId === undefined) {
      throw new Error("'templateId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/${encodeURIComponent(String(templateId))}/versions`
      .replace('{templateId}', encodeURIComponent(String(templateId)));
    const urlTemplate = `${baseUrl}/templates/{templateId}/versions`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.TemplateVersionListOutputV1>;
  }

  /**
   * @summary Get a list of templates. This endpoint is experimental and may change in future releases.
   * @param {number} [offset=0] - The pagination offset, the index of the first item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of templates that will be returned in this page of results
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getTemplates(
    {
      offset,
      limit
    } : {
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates`;
    const urlTemplate = `${baseUrl}/templates`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.TemplateOutputListV1>;
  }

  /**
   * @summary Publish a draft template as a new version. This endpoint is experimental and may change in future releases.
   * @param {string} templateId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public publishTemplateVersion(
    body: models.TemplatePublishInputV1,
    {
      templateId
    } : {
      templateId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (templateId === null || templateId === undefined) {
      throw new Error("'templateId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/${encodeURIComponent(String(templateId))}/versions`
      .replace('{templateId}', encodeURIComponent(String(templateId)));
    const urlTemplate = `${baseUrl}/templates/{templateId}/versions`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Reapply a template once by providing inputs to the template's features. This endpoint is experimental and may change in future releases.
   * @param {string} templateId
   * @param {string} instanceId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public reapplyTemplate(
    body: models.TemplateReapplicationInputV1,
    {
      templateId,
      instanceId
    } : {
      templateId: string,
      instanceId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (templateId === null || templateId === undefined) {
      throw new Error("'templateId' parameter required");
    }

    if (instanceId === null || instanceId === undefined) {
      throw new Error("'instanceId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/${encodeURIComponent(String(templateId))}/instances/${encodeURIComponent(String(instanceId))}`
      .replace('{templateId}', encodeURIComponent(String(templateId)))
      .replace('{instanceId}', encodeURIComponent(String(instanceId)));
    const urlTemplate = `${baseUrl}/templates/{templateId}/instances/{instanceId}`;



    return axiosInstance.request({
      method: 'put',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.InstanceOutputV1>;
  }

  /**
   * @summary Reapply a template to a table definition and recompute the results using the updated inputs. This endpoint is experimental and may change in future releases.
   * @param {string} templateId
   * @param {string} tableDefinitionId
   * @param {string} applicationId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public reapplyTemplateToTable(
    body: models.TableTemplateApplicationInputV1,
    {
      templateId,
      tableDefinitionId,
      applicationId
    } : {
      templateId: string,
      tableDefinitionId: string,
      applicationId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (templateId === null || templateId === undefined) {
      throw new Error("'templateId' parameter required");
    }

    if (tableDefinitionId === null || tableDefinitionId === undefined) {
      throw new Error("'tableDefinitionId' parameter required");
    }

    if (applicationId === null || applicationId === undefined) {
      throw new Error("'applicationId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/${encodeURIComponent(String(templateId))}/table-application/${encodeURIComponent(String(tableDefinitionId))}/${encodeURIComponent(String(applicationId))}`
      .replace('{templateId}', encodeURIComponent(String(templateId)))
      .replace('{tableDefinitionId}', encodeURIComponent(String(tableDefinitionId)))
      .replace('{applicationId}', encodeURIComponent(String(applicationId)));
    const urlTemplate = `${baseUrl}/templates/{templateId}/table-application/{tableDefinitionId}/{applicationId}`;



    return axiosInstance.request({
      method: 'put',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.TemplateTableApplicationOutputV1>;
  }

  /**
   * @summary Retire a template table application by ID
   * @param {string} applicationId
   * @param {boolean} [deleteColumns=false] - If true, deletes the template-controlled columns from the table definition
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public retireApplication(
    {
      applicationId,
      deleteColumns
    } : {
      applicationId: string,
      deleteColumns?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (applicationId === null || applicationId === undefined) {
      throw new Error("'applicationId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/applications/${encodeURIComponent(String(applicationId))}`
      .replace('{applicationId}', encodeURIComponent(String(applicationId)));
    const urlTemplate = `${baseUrl}/templates/applications/{applicationId}`;

    const queryParams = {
      ['deleteColumns']: deleteColumns
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.TableApplicationRetiredOutputV1>;
  }

  /**
   * @summary Retire a template instance by ID
   * @param {string} instanceId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public retireInstance(
    {
      instanceId
    } : {
      instanceId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (instanceId === null || instanceId === undefined) {
      throw new Error("'instanceId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/templates/instances/${encodeURIComponent(String(instanceId))}`
      .replace('{instanceId}', encodeURIComponent(String(instanceId)));
    const urlTemplate = `${baseUrl}/templates/instances/{instanceId}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.InstanceRetiredOutputV1>;
  }

}


export const sqTemplatesApi = new sqTemplatesApiClass();

export type sqTemplatesApiEndpoints = {
  'applyTemplate': {
    method: 'post';
    path: '/templates/${encodeURIComponent(String(templateId))}/instances';
    response: models.InstanceOutputV1;
  };
  'applyTemplateToTable': {
    method: 'post';
    path: '/templates/${encodeURIComponent(String(templateId))}/table-application/${encodeURIComponent(String(tableDefinitionId))}';
    response: models.TemplateTableApplicationOutputV1;
  };
  'archiveTemplate': {
    method: 'delete';
    path: '/templates/${encodeURIComponent(String(id))}';
    response: models.ArchiveOutputV1;
  };
  'createDraft': {
    method: 'post';
    path: '/templates/${encodeURIComponent(String(templateId))}/drafts';
    response: models.TemplateOutputV1;
  };
  'createTemplate': {
    method: 'post';
    path: '/templates';
    response: models.TemplateOutputV1;
  };
  'createTemplateFromItems': {
    method: 'post';
    path: '/templates/from-items';
    response: models.TemplateOutputV1;
  };
  'createTemplateFromTableColumnDefinitions': {
    method: 'post';
    path: '/templates/from-table-column-definitions';
    response: models.TemplateOutputV1;
  };
  'diffTemplates': {
    method: 'get';
    path: '/templates/${encodeURIComponent(String(baseTemplateId))}/diff/${encodeURIComponent(String(candidateTemplateId))}';
    response: models.TemplateCompatibilityReportOutputV1;
  };
  'duplicateTemplate': {
    method: 'post';
    path: '/templates/${encodeURIComponent(String(templateId))}/duplicate';
    response: models.TemplateOutputV1;
  };
  'editTemplate': {
    method: 'put';
    path: '/templates/${encodeURIComponent(String(templateId))}';
    response: models.TemplateOutputV1;
  };
  'editTemplateVersion': {
    method: 'put';
    path: '/templates/${encodeURIComponent(String(templateId))}/versions/${encodeURIComponent(String(versionId))}';
    response: models.TemplateOutputV1;
  };
  'generateColumnTemplate': {
    method: 'post';
    path: '/templates/templateData';
    response: models.ColumnTemplateOutput;
  };
  'getApplicationCountForTemplate': {
    method: 'get';
    path: '/templates/${encodeURIComponent(String(id))}/applicationsCount';
    response: models.ApplicationCountOutputV1;
  };
  'getAppliedTemplateTables': {
    method: 'get';
    path: '/templates/${encodeURIComponent(String(templateId))}/tables';
    response: Array<models.TableDefinitionOutputV1>;
  };
  'getDraft': {
    method: 'get';
    path: '/templates/${encodeURIComponent(String(templateId))}/draft';
    response: models.TemplateOutputV1;
  };
  'getInstance': {
    method: 'get';
    path: '/templates/instances/${encodeURIComponent(String(instanceId))}';
    response: models.InstanceOutputV1;
  };
  'getInstancesForTable': {
    method: 'get';
    path: '/templates/instances/table/${encodeURIComponent(String(tableDefinitionId))}';
    response: models.InstanceOutputPaginatedListV1;
  };
  'getInstancesForTemplate': {
    method: 'get';
    path: '/templates/${encodeURIComponent(String(templateId))}/instances';
    response: models.InstanceOutputPaginatedListV1;
  };
  'getTableDefinitionTemplateApplications': {
    method: 'get';
    path: '/templates/${encodeURIComponent(String(id))}/template-applications';
    response: models.TemplateTableApplicationsOutputListV1;
  };
  'getTemplate': {
    method: 'get';
    path: '/templates/${encodeURIComponent(String(templateId))}';
    response: models.TemplateOutputV1;
  };
  'getTemplateDependencies': {
    method: 'get';
    path: '/templates/${encodeURIComponent(String(templateId))}/dependencies';
    response: models.TemplateDependenciesOutputV1;
  };
  'getTemplateVersion': {
    method: 'get';
    path: '/templates/${encodeURIComponent(String(templateId))}/versions/${encodeURIComponent(String(versionId))}';
    response: models.TemplateOutputV1;
  };
  'getTemplateVersions': {
    method: 'get';
    path: '/templates/${encodeURIComponent(String(templateId))}/versions';
    response: models.TemplateVersionListOutputV1;
  };
  'getTemplates': {
    method: 'get';
    path: '/templates';
    response: models.TemplateOutputListV1;
  };
  'publishTemplateVersion': {
    method: 'post';
    path: '/templates/${encodeURIComponent(String(templateId))}/versions';
    response: models.StatusMessageBase;
  };
  'reapplyTemplate': {
    method: 'put';
    path: '/templates/${encodeURIComponent(String(templateId))}/instances/${encodeURIComponent(String(instanceId))}';
    response: models.InstanceOutputV1;
  };
  'reapplyTemplateToTable': {
    method: 'put';
    path: '/templates/${encodeURIComponent(String(templateId))}/table-application/${encodeURIComponent(String(tableDefinitionId))}/${encodeURIComponent(String(applicationId))}';
    response: models.TemplateTableApplicationOutputV1;
  };
  'retireApplication': {
    method: 'delete';
    path: '/templates/applications/${encodeURIComponent(String(applicationId))}';
    response: models.TableApplicationRetiredOutputV1;
  };
  'retireInstance': {
    method: 'delete';
    path: '/templates/instances/${encodeURIComponent(String(instanceId))}';
    response: models.InstanceRetiredOutputV1;
  };
};

type ApiApplyTemplateResponse = models.InstanceOutputV1;
type ApiapplyTemplateMutationParams = Parameters<typeof sqTemplatesApi.applyTemplate> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTemplatesApi.applyTemplate>;

export function useApiApplyTemplateMutation(
  options?: Omit<UseMutationOptions<ApiApplyTemplateResponse, AxiosError<SeeqErrorData>,
    ApiapplyTemplateMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiApplyTemplateResponse, AxiosError<SeeqErrorData>,
  ApiapplyTemplateMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiapplyTemplateMutationParams) =>
      sqTemplatesApi.applyTemplate(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiApplyTemplateToTableResponse = models.TemplateTableApplicationOutputV1;
type ApiapplyTemplateToTableMutationParams = Parameters<typeof sqTemplatesApi.applyTemplateToTable> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTemplatesApi.applyTemplateToTable>;

export function useApiApplyTemplateToTableMutation(
  options?: Omit<UseMutationOptions<ApiApplyTemplateToTableResponse, AxiosError<SeeqErrorData>,
    ApiapplyTemplateToTableMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiApplyTemplateToTableResponse, AxiosError<SeeqErrorData>,
  ApiapplyTemplateToTableMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiapplyTemplateToTableMutationParams) =>
      sqTemplatesApi.applyTemplateToTable(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiArchiveTemplateResponse = models.ArchiveOutputV1;
type ApiarchiveTemplateMutationParams = Parameters<typeof sqTemplatesApi.archiveTemplate> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTemplatesApi.archiveTemplate>;

export function useApiArchiveTemplateMutation(
  options?: Omit<UseMutationOptions<ApiArchiveTemplateResponse, AxiosError<SeeqErrorData>,
    ApiarchiveTemplateMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiArchiveTemplateResponse, AxiosError<SeeqErrorData>,
  ApiarchiveTemplateMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiarchiveTemplateMutationParams) =>
      sqTemplatesApi.archiveTemplate(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateDraftResponse = models.TemplateOutputV1;
type ApicreateDraftMutationParams = Parameters<typeof sqTemplatesApi.createDraft> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTemplatesApi.createDraft>;

export function useApiCreateDraftMutation(
  options?: Omit<UseMutationOptions<ApiCreateDraftResponse, AxiosError<SeeqErrorData>,
    ApicreateDraftMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateDraftResponse, AxiosError<SeeqErrorData>,
  ApicreateDraftMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApicreateDraftMutationParams) =>
      sqTemplatesApi.createDraft(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateTemplateResponse = models.TemplateOutputV1;
type ApicreateTemplateMutationParams = Parameters<typeof sqTemplatesApi.createTemplate> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTemplatesApi.createTemplate>;
type ApicreateTemplateMutationVariables = models.TemplateInputV1;

export function useApiCreateTemplateMutation(
  options?: Omit<UseMutationOptions<ApiCreateTemplateResponse, AxiosError<SeeqErrorData>,
    ApicreateTemplateMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateTemplateResponse, AxiosError<SeeqErrorData>,
  ApicreateTemplateMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateTemplateMutationVariables) =>
      sqTemplatesApi.createTemplate(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiCreateTemplateFromItemsResponse = models.TemplateOutputV1;
type ApicreateTemplateFromItemsMutationParams = Parameters<typeof sqTemplatesApi.createTemplateFromItems> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTemplatesApi.createTemplateFromItems>;
type ApicreateTemplateFromItemsMutationVariables = models.TemplateFromIdsInputV1;

export function useApiCreateTemplateFromItemsMutation(
  options?: Omit<UseMutationOptions<ApiCreateTemplateFromItemsResponse, AxiosError<SeeqErrorData>,
    ApicreateTemplateFromItemsMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateTemplateFromItemsResponse, AxiosError<SeeqErrorData>,
  ApicreateTemplateFromItemsMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateTemplateFromItemsMutationVariables) =>
      sqTemplatesApi.createTemplateFromItems(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiCreateTemplateFromTableColumnDefinitionsResponse = models.TemplateOutputV1;
type ApicreateTemplateFromTableColumnDefinitionsMutationParams = Parameters<typeof sqTemplatesApi.createTemplateFromTableColumnDefinitions> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTemplatesApi.createTemplateFromTableColumnDefinitions>;
type ApicreateTemplateFromTableColumnDefinitionsMutationVariables = models.TemplateFromIdsInputV1;

export function useApiCreateTemplateFromTableColumnDefinitionsMutation(
  options?: Omit<UseMutationOptions<ApiCreateTemplateFromTableColumnDefinitionsResponse, AxiosError<SeeqErrorData>,
    ApicreateTemplateFromTableColumnDefinitionsMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateTemplateFromTableColumnDefinitionsResponse, AxiosError<SeeqErrorData>,
  ApicreateTemplateFromTableColumnDefinitionsMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateTemplateFromTableColumnDefinitionsMutationVariables) =>
      sqTemplatesApi.createTemplateFromTableColumnDefinitions(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiDiffTemplatesResponse = models.TemplateCompatibilityReportOutputV1;
export function DiffTemplatesQueryKey(
  params: Parameters<typeof sqTemplatesApi.diffTemplates>[0],
) {
  return ['sqTemplatesApi', 'diffTemplates', params] as const;
}

export function useApiDiffTemplatesQuery(
  params: Parameters<typeof sqTemplatesApi.diffTemplates>[0],
  options?: Omit<UseQueryOptions<ApiDiffTemplatesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiDiffTemplatesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: DiffTemplatesQueryKey(params),
    queryFn: () =>
      sqTemplatesApi.diffTemplates(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiDuplicateTemplateResponse = models.TemplateOutputV1;
type ApiduplicateTemplateMutationParams = Parameters<typeof sqTemplatesApi.duplicateTemplate> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTemplatesApi.duplicateTemplate>;

export function useApiDuplicateTemplateMutation(
  options?: Omit<UseMutationOptions<ApiDuplicateTemplateResponse, AxiosError<SeeqErrorData>,
    ApiduplicateTemplateMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDuplicateTemplateResponse, AxiosError<SeeqErrorData>,
  ApiduplicateTemplateMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiduplicateTemplateMutationParams) =>
      sqTemplatesApi.duplicateTemplate(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiEditTemplateResponse = models.TemplateOutputV1;
type ApieditTemplateMutationParams = Parameters<typeof sqTemplatesApi.editTemplate> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTemplatesApi.editTemplate>;

export function useApiEditTemplateMutation(
  options?: Omit<UseMutationOptions<ApiEditTemplateResponse, AxiosError<SeeqErrorData>,
    ApieditTemplateMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiEditTemplateResponse, AxiosError<SeeqErrorData>,
  ApieditTemplateMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApieditTemplateMutationParams) =>
      sqTemplatesApi.editTemplate(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiEditTemplateVersionResponse = models.TemplateOutputV1;
type ApieditTemplateVersionMutationParams = Parameters<typeof sqTemplatesApi.editTemplateVersion> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTemplatesApi.editTemplateVersion>;

export function useApiEditTemplateVersionMutation(
  options?: Omit<UseMutationOptions<ApiEditTemplateVersionResponse, AxiosError<SeeqErrorData>,
    ApieditTemplateVersionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiEditTemplateVersionResponse, AxiosError<SeeqErrorData>,
  ApieditTemplateVersionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApieditTemplateVersionMutationParams) =>
      sqTemplatesApi.editTemplateVersion(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGenerateColumnTemplateResponse = models.ColumnTemplateOutput;
type ApigenerateColumnTemplateMutationParams = Parameters<typeof sqTemplatesApi.generateColumnTemplate> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTemplatesApi.generateColumnTemplate>;

export function useApiGenerateColumnTemplateMutation(
  options?: Omit<UseMutationOptions<ApiGenerateColumnTemplateResponse, AxiosError<SeeqErrorData>,
    ApigenerateColumnTemplateMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiGenerateColumnTemplateResponse, AxiosError<SeeqErrorData>,
  ApigenerateColumnTemplateMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApigenerateColumnTemplateMutationParams) =>
      sqTemplatesApi.generateColumnTemplate(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetApplicationCountForTemplateResponse = models.ApplicationCountOutputV1;
export function GetApplicationCountForTemplateQueryKey(
  params: Parameters<typeof sqTemplatesApi.getApplicationCountForTemplate>[0],
) {
  return ['sqTemplatesApi', 'getApplicationCountForTemplate', params] as const;
}

export function useApiGetApplicationCountForTemplateQuery(
  params: Parameters<typeof sqTemplatesApi.getApplicationCountForTemplate>[0],
  options?: Omit<UseQueryOptions<ApiGetApplicationCountForTemplateResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetApplicationCountForTemplateResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetApplicationCountForTemplateQueryKey(params),
    queryFn: () =>
      sqTemplatesApi.getApplicationCountForTemplate(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetAppliedTemplateTablesResponse = Array<models.TableDefinitionOutputV1>;
export function GetAppliedTemplateTablesQueryKey(
  params: Parameters<typeof sqTemplatesApi.getAppliedTemplateTables>[0],
) {
  return ['sqTemplatesApi', 'getAppliedTemplateTables', params] as const;
}

export function useApiGetAppliedTemplateTablesQuery(
  params: Parameters<typeof sqTemplatesApi.getAppliedTemplateTables>[0],
  options?: Omit<UseQueryOptions<ApiGetAppliedTemplateTablesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetAppliedTemplateTablesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetAppliedTemplateTablesQueryKey(params),
    queryFn: () =>
      sqTemplatesApi.getAppliedTemplateTables(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetDraftResponse = models.TemplateOutputV1;
export function GetDraftQueryKey(
  params: Parameters<typeof sqTemplatesApi.getDraft>[0],
) {
  return ['sqTemplatesApi', 'getDraft', params] as const;
}

export function useApiGetDraftQuery(
  params: Parameters<typeof sqTemplatesApi.getDraft>[0],
  options?: Omit<UseQueryOptions<ApiGetDraftResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetDraftResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetDraftQueryKey(params),
    queryFn: () =>
      sqTemplatesApi.getDraft(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetInstanceResponse = models.InstanceOutputV1;
export function GetInstanceQueryKey(
  params: Parameters<typeof sqTemplatesApi.getInstance>[0],
) {
  return ['sqTemplatesApi', 'getInstance', params] as const;
}

export function useApiGetInstanceQuery(
  params: Parameters<typeof sqTemplatesApi.getInstance>[0],
  options?: Omit<UseQueryOptions<ApiGetInstanceResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetInstanceResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetInstanceQueryKey(params),
    queryFn: () =>
      sqTemplatesApi.getInstance(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetInstancesForTableResponse = models.InstanceOutputPaginatedListV1;
export function GetInstancesForTableQueryKey(
  params: Parameters<typeof sqTemplatesApi.getInstancesForTable>[0],
) {
  return ['sqTemplatesApi', 'getInstancesForTable', params] as const;
}

export function useApiGetInstancesForTableQuery(
  params: Parameters<typeof sqTemplatesApi.getInstancesForTable>[0],
  options?: Omit<UseQueryOptions<ApiGetInstancesForTableResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetInstancesForTableResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetInstancesForTableQueryKey(params),
    queryFn: () =>
      sqTemplatesApi.getInstancesForTable(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetInstancesForTemplateResponse = models.InstanceOutputPaginatedListV1;
export function GetInstancesForTemplateQueryKey(
  params: Parameters<typeof sqTemplatesApi.getInstancesForTemplate>[0],
) {
  return ['sqTemplatesApi', 'getInstancesForTemplate', params] as const;
}

export function useApiGetInstancesForTemplateQuery(
  params: Parameters<typeof sqTemplatesApi.getInstancesForTemplate>[0],
  options?: Omit<UseQueryOptions<ApiGetInstancesForTemplateResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetInstancesForTemplateResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetInstancesForTemplateQueryKey(params),
    queryFn: () =>
      sqTemplatesApi.getInstancesForTemplate(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetTableDefinitionTemplateApplicationsResponse = models.TemplateTableApplicationsOutputListV1;
export function GetTableDefinitionTemplateApplicationsQueryKey(
  params: Parameters<typeof sqTemplatesApi.getTableDefinitionTemplateApplications>[0],
) {
  return ['sqTemplatesApi', 'getTableDefinitionTemplateApplications', params] as const;
}

export function useApiGetTableDefinitionTemplateApplicationsQuery(
  params: Parameters<typeof sqTemplatesApi.getTableDefinitionTemplateApplications>[0],
  options?: Omit<UseQueryOptions<ApiGetTableDefinitionTemplateApplicationsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetTableDefinitionTemplateApplicationsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetTableDefinitionTemplateApplicationsQueryKey(params),
    queryFn: () =>
      sqTemplatesApi.getTableDefinitionTemplateApplications(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetTemplateResponse = models.TemplateOutputV1;
export function GetTemplateQueryKey(
  params: Parameters<typeof sqTemplatesApi.getTemplate>[0],
) {
  return ['sqTemplatesApi', 'getTemplate', params] as const;
}

export function useApiGetTemplateQuery(
  params: Parameters<typeof sqTemplatesApi.getTemplate>[0],
  options?: Omit<UseQueryOptions<ApiGetTemplateResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetTemplateResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetTemplateQueryKey(params),
    queryFn: () =>
      sqTemplatesApi.getTemplate(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetTemplateDependenciesResponse = models.TemplateDependenciesOutputV1;
export function GetTemplateDependenciesQueryKey(
  params: Parameters<typeof sqTemplatesApi.getTemplateDependencies>[0],
) {
  return ['sqTemplatesApi', 'getTemplateDependencies', params] as const;
}

export function useApiGetTemplateDependenciesQuery(
  params: Parameters<typeof sqTemplatesApi.getTemplateDependencies>[0],
  options?: Omit<UseQueryOptions<ApiGetTemplateDependenciesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetTemplateDependenciesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetTemplateDependenciesQueryKey(params),
    queryFn: () =>
      sqTemplatesApi.getTemplateDependencies(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetTemplateVersionResponse = models.TemplateOutputV1;
export function GetTemplateVersionQueryKey(
  params: Parameters<typeof sqTemplatesApi.getTemplateVersion>[0],
) {
  return ['sqTemplatesApi', 'getTemplateVersion', params] as const;
}

export function useApiGetTemplateVersionQuery(
  params: Parameters<typeof sqTemplatesApi.getTemplateVersion>[0],
  options?: Omit<UseQueryOptions<ApiGetTemplateVersionResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetTemplateVersionResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetTemplateVersionQueryKey(params),
    queryFn: () =>
      sqTemplatesApi.getTemplateVersion(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetTemplateVersionsResponse = models.TemplateVersionListOutputV1;
export function GetTemplateVersionsQueryKey(
  params: Parameters<typeof sqTemplatesApi.getTemplateVersions>[0],
) {
  return ['sqTemplatesApi', 'getTemplateVersions', params] as const;
}

export function useApiGetTemplateVersionsQuery(
  params: Parameters<typeof sqTemplatesApi.getTemplateVersions>[0],
  options?: Omit<UseQueryOptions<ApiGetTemplateVersionsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetTemplateVersionsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetTemplateVersionsQueryKey(params),
    queryFn: () =>
      sqTemplatesApi.getTemplateVersions(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetTemplatesResponse = models.TemplateOutputListV1;
export function GetTemplatesQueryKey(
  params: Parameters<typeof sqTemplatesApi.getTemplates>[0],
) {
  return ['sqTemplatesApi', 'getTemplates', params] as const;
}

export function useApiGetTemplatesQuery(
  params: Parameters<typeof sqTemplatesApi.getTemplates>[0],
  options?: Omit<UseQueryOptions<ApiGetTemplatesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetTemplatesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetTemplatesQueryKey(params),
    queryFn: () =>
      sqTemplatesApi.getTemplates(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiPublishTemplateVersionResponse = models.StatusMessageBase;
type ApipublishTemplateVersionMutationParams = Parameters<typeof sqTemplatesApi.publishTemplateVersion> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTemplatesApi.publishTemplateVersion>;

export function useApiPublishTemplateVersionMutation(
  options?: Omit<UseMutationOptions<ApiPublishTemplateVersionResponse, AxiosError<SeeqErrorData>,
    ApipublishTemplateVersionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiPublishTemplateVersionResponse, AxiosError<SeeqErrorData>,
  ApipublishTemplateVersionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApipublishTemplateVersionMutationParams) =>
      sqTemplatesApi.publishTemplateVersion(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiReapplyTemplateResponse = models.InstanceOutputV1;
type ApireapplyTemplateMutationParams = Parameters<typeof sqTemplatesApi.reapplyTemplate> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTemplatesApi.reapplyTemplate>;

export function useApiReapplyTemplateMutation(
  options?: Omit<UseMutationOptions<ApiReapplyTemplateResponse, AxiosError<SeeqErrorData>,
    ApireapplyTemplateMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiReapplyTemplateResponse, AxiosError<SeeqErrorData>,
  ApireapplyTemplateMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApireapplyTemplateMutationParams) =>
      sqTemplatesApi.reapplyTemplate(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiReapplyTemplateToTableResponse = models.TemplateTableApplicationOutputV1;
type ApireapplyTemplateToTableMutationParams = Parameters<typeof sqTemplatesApi.reapplyTemplateToTable> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTemplatesApi.reapplyTemplateToTable>;

export function useApiReapplyTemplateToTableMutation(
  options?: Omit<UseMutationOptions<ApiReapplyTemplateToTableResponse, AxiosError<SeeqErrorData>,
    ApireapplyTemplateToTableMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiReapplyTemplateToTableResponse, AxiosError<SeeqErrorData>,
  ApireapplyTemplateToTableMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApireapplyTemplateToTableMutationParams) =>
      sqTemplatesApi.reapplyTemplateToTable(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiRetireApplicationResponse = models.TableApplicationRetiredOutputV1;
type ApiretireApplicationMutationParams = Parameters<typeof sqTemplatesApi.retireApplication> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTemplatesApi.retireApplication>;

export function useApiRetireApplicationMutation(
  options?: Omit<UseMutationOptions<ApiRetireApplicationResponse, AxiosError<SeeqErrorData>,
    ApiretireApplicationMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiRetireApplicationResponse, AxiosError<SeeqErrorData>,
  ApiretireApplicationMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiretireApplicationMutationParams) =>
      sqTemplatesApi.retireApplication(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiRetireInstanceResponse = models.InstanceRetiredOutputV1;
type ApiretireInstanceMutationParams = Parameters<typeof sqTemplatesApi.retireInstance> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTemplatesApi.retireInstance>;

export function useApiRetireInstanceMutation(
  options?: Omit<UseMutationOptions<ApiRetireInstanceResponse, AxiosError<SeeqErrorData>,
    ApiretireInstanceMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiRetireInstanceResponse, AxiosError<SeeqErrorData>,
  ApiretireInstanceMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiretireInstanceMutationParams) =>
      sqTemplatesApi.retireInstance(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
